import Vue from "vue";
import Vuex from "vuex";
import state from "./state";
import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

Vue.use(Vuex);

import extendedState from "./extend.state";
import extendedActions from "./extend.actions";
import extendedMutations from "./extend.mutations";
import extendedGetters from "./extend.getters";


export default new Vuex.Store({
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
    modules: {
        ts: {
            namespaced: true,
            state: extendedState,
            getters:extendedGetters,
            mutations: extendedMutations,
            actions: extendedActions,
        }
    }
});
